// src/pages/AdminAccessories/AccessoryTable.jsx
import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Chip,
  Tooltip,
  Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const AccessoryTable = ({ data, onEdit, onDelete }) => {
  return (
    <TableContainer
      component={Paper}
      sx={{
        overflowX: "auto",
        borderRadius: 2,
        border: "1px solid #ddd",
      }}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>
              <strong>Internal Name</strong>
            </TableCell>
            <TableCell>
              <strong>Display Name</strong>
            </TableCell>
            <TableCell>
              <strong>Category</strong>
            </TableCell>
            <TableCell>
              <strong>Price</strong>
            </TableCell>
            <TableCell>
              <strong>Customizations</strong>
            </TableCell>
            <TableCell>
              <strong>Visible</strong>
            </TableCell>
            <TableCell align="right">
              <strong>Actions</strong>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((item) => (
            <TableRow key={item._id}>
              <TableCell>{item.name}</TableCell>
              <TableCell>{item.displayName}</TableCell>
              <TableCell>{item.category}</TableCell>
              <TableCell>${item.price.toFixed(2)}</TableCell>

              <TableCell>
                {item.customizationOptions?.length > 0 ? (
                  item.customizationOptions.map((c, idx) => (
                    <Chip
                      key={idx}
                      label={c.type}
                      size="small"
                      color="primary"
                      sx={{ mr: 0.5, mb: 0.5 }}
                    />
                  ))
                ) : (
                  <Typography variant="body2" color="text.secondary">
                    None
                  </Typography>
                )}
              </TableCell>

              <TableCell>
                <Chip
                  label={item.visible ? "Yes" : "No"}
                  color={item.visible ? "success" : "default"}
                  size="small"
                  variant={item.visible ? "filled" : "outlined"}
                />
              </TableCell>

              <TableCell align="right">
                <Tooltip title="Edit" placement="top">
                  <IconButton
                    onClick={() => onEdit(item)}
                    sx={{ color: "#6E6E6E" }}>
                    <EditIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Delete" placement="top">
                  <IconButton
                    onClick={() => onDelete(item._id)}
                    sx={{ color: "#6E6E6E" }}>
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="More Info" placement="top">
                  <IconButton
                    onClick={() => console.log("View details for", item)}
                    sx={{ color: "#6E6E6E" }}>
                    <InfoOutlinedIcon />
                  </IconButton>
                </Tooltip>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default AccessoryTable;
